(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["powr-form-builder"]) return;
  try {
    
//<script>
   // whole sale 页面内部跳转

         var jumpButtons = document.getElementsByClassName('jump_to_class');
         for (var i = 0; i < jumpButtons.length; i++) {
              jumpButton = jumpButtons[i]
             // 找到目标元素
             var targetElement = document.getElementsByClassName('powr-form-builder')[0];

             // 点击按钮时触发滚动
             jumpButton.addEventListener('click', function() {
                 // 计算目标元素相对于文档顶部的偏移量
                 var offsetTop = targetElement.offsetTop;

                 // 滚动到目标元素位置
                 window.scrollTo({
                     top: offsetTop,
                     behavior: 'smooth'
                 });
             });
         }
         //</script>

  } catch(e) { console.error(e); }
})();
})();
